import { useState, useEffect } from 'react'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

type Lookup = {
    id: number
    name_th: string
    name_en: string
}

const useStatus = () => {
    const callApi = useCallApi()
    const [statusList, setstatusList] = useState<Lookup[]>([])

    useEffect(() => {
        getLookup()
    }, [])

    const getLookup = async () => {
        try {
            const { data } = await callApi.axiosGet<any>({
                url: `${process.env.REACT_APP_CU_IRB_API_URL}/lookups/userStatus`,
            })

            setstatusList(data.result)
        } catch (error) {
            console.log('error', error)
        }
    }

    return { statusList }
}

export default useStatus
